/**
 * Product card slider component
 */
export default {
  render: function (createElement) {
    return createElement('style', this.$slots.default);
  },
};
